// extracted by mini-css-extract-plugin
module.exports = {"submitBox":"FormContattaci_submitBox__a0vhq","rotation":"FormContattaci_rotation__gnnff"};